import { FormCombination, FormWordGroup } from '../models/ComboFormState';

export interface CreateComboTooltip {
  title: string;
}

export function useComboTooltipHint(
  cc: FormCombination,
  wordGroups: FormWordGroup[]
): CreateComboTooltip {
  const tooltipHint = cc.wordGroups.some(
    (CCwg) => wordGroups.find((wg) => wg.id === CCwg.id)?.words === ''
  )
    ? 'This combination is missing keywords'
    : 'Example combination: ' +
      cc.wordGroups
        .map((CCwg, index) => {
          const name = wordGroups.find((wg) => wg.id === CCwg.id).words.split('\n')[0];
          if (cc.removeSpacing === 0) {
            const separator = index === cc.wordGroups.length - 1 ? '' : ' ';
            return `${name}${separator}`;
          } else {
            const separator =
              index === cc.removeSpacing - 1 || index === cc.wordGroups.length - 1 ? '' : ' ';
            return `${name}${separator}`;
          }
        })
        .join('');
  return { title: tooltipHint };
}
